// extracted by mini-css-extract-plugin
export default {"primaryBtn":"primary-button_primaryBtn__h9jiy","primaryBtnText":"primary-button_primaryBtnText__Nf2Tb"};